/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import UpgradeModal from 'app/components/Subscription/UpgradeModal.jsx';
import { Breakpoint } from 'react-socks';

class FeatureUpgradeComponent extends React.Component {
    constructor(props) {
        super(props);

        this.videoClick = this.videoClick.bind(this);

    }

    componentDidMount(prevProps, nextProps) {

        let constants = this.props.app.config.constants,
            type = (this.props.isFreeUser()) ? 'new' : 'upgrade';

        // have to track contentImport outside of the upgrade modal because
        // it uses a video and not the modal
        if (this.props.context === 'contentImport') {
            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Upgrade Prompt View',
                    event_data: {
                        type: "Content Import " + type + " Video"
                    }
                })
            }

            // if (dataLayer) {
            //     dataLayer.push({
            //         'event': 'promotionView',
            //         'ecommerce': {
            //             'promoView': {
            //                 'promotions': [
            //                     {
            //                         'id': 'contentImport',
            //                         'name': "Content Import",
            //                         'creative': "Content Import " + type + " Video",
            //                         'position': this.props.trigger
            //                     }
            //                 ]
            //             }
            //         },
            //         //GA 4 params
            //         'promotion_id': 'contentImport',
            //         'promotion_name': 'Content Import',
            //         'creative_name': "Content Import " + type + " Video",
            //         'creative_slot': this.props.trigger,
            //         items: [
            //             {
            //                 item_id: 'dlvrit_1',
            //                 item_name: 'dlvr.it premium plan',
            //                 price: 1.00,
            //                 quantity: 1
            //             }
            //         ]
            //     });
            // }

            if (gtag) {
                gtag('event', 'view_promotion', {
                    'promotion_id': 'contentImport',
                    'promotion_name': 'Content Import',
                    'creative_name': "Content Import " + type + " Video",
                    'creative_slot': this.props.trigger,
                    items: [
                        {
                            item_id: 'dlvrit_1',
                            item_name: 'dlvr.it premium plan',
                            price: 1.00,
                            quantity: 1
                        }
                    ]
                });
            }
        }

    }

    videoClick(e) {
        let constants = this.props.app.config.constants,
            type = (this.props.isFreeUser()) ? 'new' : 'upgrade',
            redirector = () => {
                if (this.props.isFreeUser()) {
                    this.props.router.navigate('/account/subscription/new?plan=9');
                } else {
                    this.props.router.navigate('/account/subscription/change?plan=9');
                }

            };

        e.preventDefault();

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Upgrade Prompt Click',
                event_data: {
                    type: "Content Import " + type + " Video"
                }
            })
        }



        // if (dataLayer && window.ga && ga.loaded) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [
        //                     {
        //                         'id': 'contentImport',
        //                         'name': 'Content Import',
        //                         'creative': "Content Import " + type + " Video",
        //                         'position': this.props.trigger
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'contentImport',
        //         'promotion_name': 'Content Import',
        //         'creative_name': "Content Import " + type + " Video",
        //         'creative_slot': this.props.trigger,
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': 'contentImport',
                'promotion_name': 'Content Import',
                'creative_name': "Content Import " + type + " Video",
                'creative_slot': this.props.trigger,
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': 'contentImport',
                'promotion_name': 'Content Import',
            });
        }

        redirector();

    }

    render() {
        let imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            backgroundUrl = '',
            background2x = '';

        switch (this.props.context) {
            case 'everqueue':
                backgroundUrl = imageUrl + "/upgrade-assets/EQ-tab-grab.png";
                background2x = imageUrl + "/upgrade-assets/EQ-tab-grab@2x.png";
                break;

            case 'contentImport':
                return (
                    <div className="plus-feature-upgrade">
                        <Breakpoint desktop only>
                            <div className="video-container">
                                <iframe src="https://player.vimeo.com/video/276331176?loop=1&title=0&byline=0&portrait=0" width="640" height="408" border="0" frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen={true}></iframe>
                            </div>
                        </Breakpoint>
                        <Breakpoint mobile only>
                            <div className="video-container">
                                <iframe src="https://player.vimeo.com/video/276331176?loop=1&title=0&byline=0&portrait=0" width="100%" height="auto" border="0" frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen={true}></iframe>
                            </div>
                        </Breakpoint>
                        <div className="video-upgrade-button">
                            <button className="btn-primary fixed active" onClick={this.videoClick}>
                                Instantly Import & Schedule Weeks of Posts
                            </button>
                        </div>
                    </div>
                );

            case 'importConnections':
                backgroundUrl = imageUrl + "/upgrade-assets/Import-tab.png";
                background2x = imageUrl + "/upgrade-assets/Import-tab@2x.png";
                break;

            case 'category':
                backgroundUrl = imageUrl + "/upgrade-assets/Category.png";
                background2x = imageUrl + "/upgrade-assets/Category@2x.png";
                break;

            case 'users':
                backgroundUrl = imageUrl + "/upgrade-assets/teams-paywall.png";
                background2x = imageUrl + "/upgrade-assets/teams-paywall@2x.png";
                break;

            case 'clients':
                backgroundUrl = imageUrl + "/upgrade-assets/client-paywall.png";
                background2x = imageUrl + "/upgrade-assets/client-paywall@2x.png";
                break;

            default:
                return null;
        }

        return (
            <div className="plus-feature-upgrade">
                <UpgradeModal
                    {...this.props}
                    hasBackground={false}
                    trialEligible={this.props.user.detail.trialEligible}
                    context={this.props.context}/>
                <img src={backgroundUrl} srcSet={background2x + " 2x"} className="place-holder-image" />
            </div>
        );
    }
}

FeatureUpgradeComponent.displayName = "FeatureUpgradeComponent";

export default FeatureUpgradeComponent;
